import React from 'react';
import { CAlert, CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react';
import _t from 'counterpart';
import toast from 'react-hot-toast';

interface IProps {
  walletId: number;
  password: string;
  onClose: () => void;
}

/**
 * Shows an MT5 master password after a reset or an explicit reveal. The value is held in
 * component state only — it is never written to the query cache, so it disappears with the modal
 * and cannot be read back off a cached wallet.
 */
const Mt5CredentialsModal = ({ walletId, password, onClose }: IProps) => {
  const copyPassword = async () => {
    await navigator.clipboard.writeText(password);
    toast.success(_t('wallet.mt5-password-copied'));
  };

  return (
    <CModal show onClose={onClose} closeOnBackdrop={false}>
      <CModalHeader closeButton>
        <CModalTitle>{_t('wallet.mt5-credentials')}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <dl>
          <dt>{_t('customer.wallets.accountId')}:</dt>
          <dd>{walletId}</dd>
          <dt>{_t('wallet.mt5-master-password')}:</dt>
          <dd>
            <code data-testid="mt5-password">{password}</code>
          </dd>
        </dl>
        <CAlert color="warning" className="mb-0">
          {_t('wallet.mt5-password-audit-note')}
        </CAlert>
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" className="mr-2" onClick={copyPassword}>
          {_t('action.copy')}
        </CButton>
        <CButton color="light" variant="outline" onClick={onClose}>
          {_t('action.cancel')}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default Mt5CredentialsModal;
